import appEvents from 'constants/appEvents.constant';
import mainEvents from 'modules/main/config/events.constant';
import {flightStates} from '../../flights/flights-routes';
import {hotelStates} from '../../hotels/hotels-routes';
import {carStates} from '../../cars/cars-routes';
import {railStates} from '../../ukrail/ukrail-routes';
import {tripStates} from '../../trip/trip-routes';

export default function FooterController(
    $scope,
    $rootScope,
    $state,
    hotelsFactory,
    basketService,
    tripFactory,
    tripAPI,
    flightsUtils,
    userService,
    availableServices,
    l10nService,
    sidebarService,
    railAmendmentService,
    moment
) {
    'ngInject';
    const vm = this;

    Object.assign(vm, {
        $onInit,
        hideBasket,
        searchForSuitableHotelForTheTrip,
        isAmendmentMode: () => railAmendmentService.isAmendmentMode(),
        navigateTo,
        isFlightSearchAvailable: sidebarService.isFlightSearchAvailable,
        isHotelSearchAvailable: sidebarService.isHotelSearchAvailable,
        isCarSearchAvailable: sidebarService.isCarSearchAvailable,
        isEurostarSearchAvailable: sidebarService.isEurostarSearchAvailable,
        isRailSearchAvailable: sidebarService.isRailSearchAvailable,
        airportShouldBeHighlighted: flightsUtils.airportShouldBeHighlighted,
        moment,
    });

    function $onInit() {
        initStates();
    }

    $scope.isWarningPanelVisible = function() {
        const {validation} = $scope;
        return validation.messages.warnings.length
            && !validation.messages.errors.length
            && validation.messages.payment.isValid;
    };

    function hideBasket() {
        $scope.showBasket = false;
    }

    function searchForSuitableHotelForTheTrip() {
        const params = basketService.getParamsToSearchForSuitableHotel();
        if (params) {
            hotelsFactory.openDropdown = true;
            hotelsFactory.address = `${params.city}`;

            hotelsFactory.setFormData({
                checkInDate: moment(params.fromDate).format(userService.getRegionalSettings().dateFormat),
                checkOutDate: moment(params.toDate).format(userService.getRegionalSettings().dateFormat),
                roomsQuantity: (params.travelers.adult + params.travelers.child + params.travelers.infant),
                occupantsQuantity: 1,
            });
        }

        $state.go(hotelStates.MAIN, {}, {reload: true});
    }

    const validation = {
        visible: false,
        messages: {
            errors: [],
            payment: {
                isValid: false,
                methods: [],
            },
            warnings: false,
        },
    };

    $scope.validation = angular.copy(validation);
    $scope.availableServices = availableServices || {};
    $scope.isCanBookByTime = tripFactory.isCanBookByTime();
    $scope.isUserHaveRules = userService.isCheckoutAllowed();
    $scope.hasOperator = flightsUtils.hasOperator;
    $scope.getOperator = flightsUtils.getOperator;
    $scope.toggleBasket = basketService.toggleBasket;
    $scope.showBasket = false;
    $scope.showUserMenu = false;
    $scope.testClick = testClick;
    $scope.moment = moment;

    $rootScope.$on(mainEvents.TOGGLE_USER_MENU, function(event, userMenuState) {
        $scope.userMenuState = userMenuState;
    });
    $rootScope.$on(mainEvents.TOGGLE_BASKET, function(event, basketState) {
        $scope.basketState = basketState;
    });

    $rootScope.$broadcast(mainEvents.TOGGLE_BASKET, $scope.showBasket);
    $rootScope.$on(mainEvents.HIDE_BASKET, () => basketService.toggleBasket($scope));
    $rootScope.$on(mainEvents.SHOW_BASKET, () => basketService.toggleBasket($scope));
    $rootScope.$on(appEvents.UPDATE_BASKET_VALIDATION, updateValidation);
    $scope.$on(appEvents.AVAILABLE_SERVICES_CHANGE, (event, services) => {
        $scope.availableServices = services;
    });

    $scope.standardUser = $rootScope.isStandardUser;

    $scope.temporaryTripId = null;

    $scope.canQuote = function() {
        return $rootScope.basket.count
            && !$scope.validation.visible
            && !$scope.validation.messages.warnings;
    };

    $scope.canBookOrHold = function() {
        return $scope.canQuote()
            && $scope.isUserHaveRules
            && $scope.isCanBookByTime;
    };

    $scope.bookAttrTitle = function() {
        let attrTitle = '';
        if (!$scope.isCanBookByTime) {
            attrTitle = l10nService.localize('Please contact Key Travel to book this option'
                + ' as it is close to the departure time');
        }
        if (!$scope.isUserHaveRules) {
            attrTitle = l10nService.localize('There may be rules for your department that prevent'
                + ' this itinerary being booked, please re-create it to verify');
        }
        return attrTitle;
    };

    $scope.checkSameAirports = function(flightSegments, segmentIndex, departureBlock) {
        const segmentsData = [];

        angular.forEach(flightSegments, function(segment, index) {
            const flightIndex = (index) ? segment.flights.length - 1 : 0;
            segmentsData.push(segment.flights[flightIndex]);
        });

        return flightsUtils.checkSameAirports(segmentsData, segmentIndex, departureBlock);
    };

    $scope.removeCar = function(index) {
        basketService.removeCar(index);
        updateValidation();
    };

    $scope.removeHotel = function(index) {
        basketService.removeHotel(index);
        updateValidation();
    };

    $scope.removeFlight = function(index) {
        basketService.removeFlight(index);
        updateValidation();
    };

    $scope.removeRail = function(index) {
        basketService.removeRail(index);
        updateValidation();
    };

    $scope.removeEuRail = function(index) {
        basketService.removeEuRail(index);
        updateValidation();
    };

    $scope.clearBasket = function() {
        $scope.validation.visible = false;
        $scope.validation.messages.warnings = false;
        basketService.clearBasket();
    };


    $scope.isFlightTrain = function(flight) {
        return flight.company === 'Eurostar' || flight.company === 'Amtrak';
    };

    function initStates() {
        vm.hotelSearchState = hotelStates.MAIN;
        vm.flightSearchState = flightStates.ROUNDTRIP;
        vm.railSearchState = railStates.ROUNDTRIP;
        vm.carSearchState = carStates.MAIN;
    }

    function navigateTo(state) {
        $scope.showBasket = false;
        $rootScope.$broadcast(mainEvents.TOGGLE_BASKET, $scope.showBasket);
        $state.go(state);
    }

    $scope.createQuote = function(showSendBlock) {
        const requestParams = {ShouldValidate: false};
        tripAPI.createTrip(requestParams)
            .then((response) => {
                basketService.toggleBasket($scope);
                basketService.clearBasket();
                if (showSendBlock) {
                    tripFactory.showSendTripBlock();
                }
                $state.go(tripStates.TRIP_DETAILS, {id: response.TripId});
            }
        );
    };

    $scope.cancelWarning = function() {
        const {errors, payment} = $scope.validation.messages;
        if (!errors.length && payment.isValid) {
            $scope.validation.visible = false;
        }
        $scope.validation.messages.warnings = false;
    };

    $scope.continueTrip = function() {
        $scope.validation.visible = false;
        $scope.validation.messages.warnings = false;

        const requestParams = {ShouldValidate: false};

        tripAPI.createTrip(requestParams)
            .then((response) => {
                basketService.toggleBasket($scope);
                tripFactory.showCheckout(response.TripId, null, null, true);
            });
    };

    $scope.bookTrip = function() {
        $scope.validation.visible = false;
        $scope.validation.messages.warnings = false;

        const requestParams = {ShouldValidate: true};

        tripAPI.createTrip(requestParams)
            .then(handleTripCreation);
    };

    function updateValidation() {
        $scope.validation = angular.copy(validation);
        $scope.isCanBookByTime = tripFactory.isCanBookByTime();
    }

    function handleTripCreation(response) {
        const validationInfo = tripFactory.getValidationInfo(response);

        if (validationInfo.isValid && !validationInfo.warning.length) {
            basketService.toggleBasket($scope);
            tripFactory.showCheckout(response.TripId, null, validationInfo, true);
        } else {
            $scope.validation = {
                visible: true,
                messages: {
                    errors: validationInfo.errors,
                    payment: {
                        isValid: validationInfo.paymentsValid,
                        methods: validationInfo.paymentMethods,
                    },
                    warnings: validationInfo.warning,
                },
            };

            basketService.scrollBasketToBottom();
        }
    }
    function testClick() {
        hideBasket();
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/main/controllers/footerController.js